import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    undoActions: [],
};

const estimateUndoSlice = createSlice({
    name: 'estimateUndo',
    initialState,
    reducers: {
        changeStepId: (state, { payload }) => {
            const { oldStepId, newStepId } = payload;

            const updatedState = state.undoActions.map((action) => {
                if (action.action !== 'remove') return action;

                return {
                    ...action,
                    positions: action.positions.map((pos) =>
                        pos.stepId === oldStepId ? { ...pos, stepId: newStepId } : pos
                    ),
                };
            });

            state.undoActions = updatedState;
        },
        addUndoAction: (state, { payload }) => {
            state.undoActions.push(payload);
            if (state.undoActions.length === 1) {
                $(document).find('.undoActionButton').css('display', 'flex');
            }
        },
        popUndoAction: (state) => {
            state.undoActions.pop();
            if (state.undoActions.length === 0) {
                $(document).find('.undoActionButton').hide();
            }
        },
    },
});

export const { actions: estimateUndoActions } = estimateUndoSlice;
export const { reducer: estimateUndoReducer } = estimateUndoSlice;

// <script>
//     const state = MyApp.store.getState();
//     const value = state.estimateUndoReducer.fetchFilesLoading;
//     MyApp.store.dispatch(MyApp.actions.estimateUndo.setFetchFilesLoading(true));
//     console.log('📦 Значение:', value);
// </script>
